import { render } from "./HomeFoot.vue?vue&type=template&id=10075250&scoped=true"
import script from "./HomeFoot.vue?vue&type=script&lang=js"
export * from "./HomeFoot.vue?vue&type=script&lang=js"

import "./HomeFoot.vue?vue&type=style&index=0&id=10075250&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.18_vue@3.5.18_webpack@5.101.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10075250"]])

export default __exports__